import { render, staticRenderFns } from "./TradeBtn.vue?vue&type=template&id=9d2d6288&scoped=true&"
import script from "./TradeBtn.vue?vue&type=script&lang=ts&"
export * from "./TradeBtn.vue?vue&type=script&lang=ts&"
import style0 from "./TradeBtn.vue?vue&type=style&index=0&id=9d2d6288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2d6288",
  null
  
)

export default component.exports